import { motion } from 'framer-motion'
import Card from './ui/Card'
import Button from './ui/Button'
import Badge from './ui/Badge'

const MotionCard = motion.create(Card)

const item = { hidden: { opacity: 0, y: 8 }, show: { opacity: 1, y: 0 } }

const ARTIFACT_LABELS = {
    huggingface: '🤗 Try on HuggingFace',
    colab: 'Open in Colab',
    notebook: 'View Notebook',
    demo: 'Live Demo',
    other: 'View Artifact'
}

export default function ProjectCard({ title, description, url, image, category, subcategory, featured, techStack = [], artifactType, artifactUrl, large = false }) {
    return (
        <MotionCard
            variants={item}
            whileHover={{ y: -2 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20, mass: 0.6 }}
            accent={featured}
            className={`group relative flex w-full flex-col p-4 shadow-brutal hover:shadow-brutal-hover ${large ? 'md:flex-row md:gap-6 min-h-[280px] md:min-h-[320px]' : 'max-w-sm min-h-[430px]'}`}
        >
            {featured && (
                <span className="absolute -top-3 -left-3 z-10 border-2 border-black bg-accent px-2.5 py-1 font-mono text-[11px] font-bold uppercase tracking-wide text-black shadow-brutal-sm dark:border-white">
                    ★ Featured
                </span>
            )}

            {image && (
                <div className={`relative overflow-hidden border-2 border-black bg-zinc-100 dark:border-white dark:bg-zinc-900 w-full ${large ? 'mb-4 md:mb-0 h-48 md:h-auto md:w-1/2 flex-shrink-0' : 'mb-4 h-48'}`}>
                    <img
                        src={image}
                        alt={title}
                        className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                    />
                </div>
            )}

            <div className={large ? 'flex flex-col md:justify-center' : 'contents'}>
            <h2 className={`font-serif font-bold transition-colors text-black dark:text-white group-hover:text-accent ${large ? 'text-2xl md:text-3xl' : 'text-lg'}`}>{title}</h2>
            <p className="mt-0.5 text-xs text-zinc-600 dark:text-zinc-400">
                {category?.title}{subcategory?.title ? ` / ${subcategory.title}` : ''}
            </p>

            <p className={`mt-2 text-zinc-700 dark:text-zinc-300 ${large ? 'text-base' : 'text-sm'}`}>{description}</p>

            <div className="mt-5 flex flex-wrap items-center gap-2.5">
                {url && (
                    <Button as="a" href={url} target="_blank" rel="noopener noreferrer" variant="primary">
                        View Project ↗
                    </Button>
                )}
                {artifactUrl && (
                    <Button as="a" href={artifactUrl} target="_blank" rel="noopener noreferrer" variant="secondary">
                        {ARTIFACT_LABELS[artifactType] || 'View Artifact'} ↗
                    </Button>
                )}
            </div>

            {Array.isArray(techStack) && techStack.length > 0 && (
                <ul className="mt-4 flex flex-wrap gap-2">
                    {techStack.slice(0, 8).map((tech, i) => (
                        <li key={i} title={tech}>
                            <Badge tone={featured ? 'accent' : 'default'}>{tech}</Badge>
                        </li>
                    ))}
                    {techStack.length > 8 && (
                        <li title={techStack.slice(8).join(', ')}>
                            <Badge>+{techStack.length - 8} more</Badge>
                        </li>
                    )}
                </ul>
            )}
            </div>
        </MotionCard>
    )
}
